







import Vue from "vue";
import { highlight } from "@/directives/highlight";

export default Vue.extend({
  name: "CodeView",
  props: {
    sourcecode: String
  },
  directives: { highlight }
});
